import ViewBase from "../../view-base.view";
import 'CssFolder/schedule/jpo/jpo-timeline.scss';
import { Button,  Icon, Icons, Intent } from 'construct-ui';
import paginationComponent from "../../../components/pagination/pagination.component";

export default function JPOScheduleTimeLineView() {
    ViewBase.call(this);
    const hours = ['9:00 AM', '9:30 AM', '10:00 AM', '10:30 AM', '11:00 AM', '11:30 AM', '12:00 PM', '12:30 PM', '1:00 PM', '1:30 PM', '2:00 PM', '2:30 PM', '3:00 PM', '3:30 PM', '4:00 PM', '4:30 PM', '5:00 PM', '5:30 PM', '6:00 PM', '6:30 PM', '7:00 PM', '7:30 PM'];
    let schedules = [];
    let colors = [];
    let _schedules = [];
    let _attrs;
    let pagination={};
    let isDisplay = true;
    let dataVersion="";

    const onPageSizeChanged = (_, pageSize) => {
        pagination.pageSize = pageSize;
        _attrs.onPageChanged(pagination);
    }
    const onPageChanged = (pageIndex) => {
        pagination.pageIndex = pageIndex;
        _attrs.onPageChanged(pagination);
    }
 
    const loadRoutes = () => {
        _schedules=[];
        var userid = "";
        var index;
        schedules.forEach(s => {
            if (userid != s.userID) {
                userid = s.userID;
                _schedules.push({
                    userID: s.userID,
                    userName: s.userName,
                    scheduleDate: s.scheduleDate,
                    routes: [],
                    totalTime: 0
                });
                index = _schedules.length - 1;
            }
            //_schedules[index].totalTime += (s.planDwellTime * 60) + (s.sequence==1? 0:s.planTravelingTime);
            _schedules[index].totalTime += (s.planDwellTime * 60) + s.planTravelingTime;
            _schedules[index].routes.push({
                startTimeNum: getTimeNum(s.startTime),
                endTimeNum: getTimeNum(s.endTime),
                sequence: s.sequence,
                siteId: s.siteId,
                siteName: s.siteName,
                startTime: s.startTime,
                endTime: s.endTime
            });


        });
        
        m.redraw();
    }

    const getTimeNum = (time) => {
        var t = ((parseInt(time.split(':')[0]) - 8) * 240) - 180;
        t += parseInt(time.split(':')[1]) * 4;
        return t;
    }


    return {
        oninit: ({ attrs }) => {
            _attrs=attrs;
            schedules = attrs.schedules;
            pagination= attrs.pagination;
            colors= attrs.colors;
            loadRoutes();
        },
        oncreate: function (vnode) {

        },
        onupdate: (vnode) => {
            if(vnode.attrs.dataVersion!==dataVersion){
                schedules=vnode.attrs.schedules;
                dataVersion=vnode.attrs.dataVersion;
                loadRoutes();
            }
            pagination= vnode.attrs.pagination;
       
        },
        view: (vnode) => {
            return [
                m('.form-ctr.card.shadow-border timeline', { class: `${isDisplay ? 'show' : 'hide'}` }, [
                    m('.tl-tab-top'),
                    m('.tl-tab', {
                        onclick: () => { isDisplay = !isDisplay; }
                    }, [
                        m('div', { style: "flex: 1;" }, 'Timeline'),
                        m(Icon,
                            {
                                name: isDisplay ? Icons.CHEVRON_DOWN : Icons.CHEVRON_UP,
                                intent: Intent.PRIMARY
                            }
                        )
                    ]),
                    m('.card-body', [
                        m('.tl-ctr',
                            m('table', [

                                m('tr',
                                    [
                                        m('th', ' '),
                                        m('th',
                                            m('div',
                                                m('.tl-hdr',
                                                    hours.map((h, i) => [
                                                        m('div.tl-time', { style: "width:" + ((i + 1) * 4.545454545) + ";" },
                                                            [
                                                                m('div', h),
                                                                m('div.vline', '|')
                                                            ]
                                                        )
                                                    ])
                                                )
                                            )
                                        )
                                    ]
                                ),
                                _schedules.map((schedule,idx) => [
                                    m('tr', { style: "" }, [
                                        m('td', [
                                            m('div', { style: "position: absolute;left: 10px;display:none" },
                                                m('input[class="form-check-input me-2"][type="checkbox"]')
                                            ),
                                            m('div', { style: "position: absolute;right: 10px;" }, m(Button, {
                                                style: 'margin: 5px; background: #009ef7;border-color: transparent;',
                                                iconLeft: Icons.FILE_TEXT,
                                                intent: 'primary',
                                                size: 'xs',
                                                onclick: () => { _attrs.onDetailsView(schedule,idx); }
                                            })),
                                            m('div', { style: "padding-left:30px;padding-right: 32px;" }, `${schedule.userName}`),
                                            m('.tl-sub-title', { style: "padding-left:30px" }, `${schedule.routes.length} Store(s) -${(schedule.totalTime / 3600) >= 1 ? `${parseInt(schedule.totalTime / 3600)} hour` : ''} ${parseInt((schedule.totalTime % 3600) / 60)} min`)
                                        ]),
                                        m('td', { style: "padding 0px 0px;" },
                                            m('div', { style: "position:relative;width:100%" }, [
                                                schedule.routes.map((r, i) => m('div.tl-time-block', { style: `border-color:rgba(${colors[idx][0]},${colors[idx][1]},${colors[idx][2]});left:${r.startTimeNum}px;width:${r.endTimeNum - r.startTimeNum}px;`, title: `${i + 1}. ${r.siteName}\n (${r.startTime} ~ ${r.endTime})` }, `${i + 1}. ${r.siteName}`)),
                                                m('.tl-hline', { style: `background-color:rgba(${colors[idx][0]},${colors[idx][1]},${colors[idx][2]});left:${schedule.routes[0].startTimeNum}px;width:${schedule.routes[schedule.routes.length - 1].endTimeNum - schedule.routes[0].startTimeNum}px;` })
                                            ]

                                            )
                                        )
                                    ])
                                ])

                            ]
                            )
                        ),
                        m(".px-3 pt-2 pg-ctr",
                            m(paginationComponent, {showPageSize:false, currentPage: pagination.pageIndex, pageSize: pagination.pageSize, totalItems: pagination.total, onPageChanged: onPageChanged, onPageSizeChanged: onPageSizeChanged })
                        )
                    ]

                    )
                ]
                ),
                this.getBaseViews()
            ];
        }
    }
}